
const Index = r => require.ensure([], () => r(require('./Index')), 'H5APP')
const H5APP = r => require.ensure([], () => r(require('./H5-APP')), 'H5APP')

export default {
  path: '/newimg',
  component: Index,
  children: [
    {
      path: 'newimg',
      name: 'newimg',
      component: H5APP
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/newImg/router.js